import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Start } from './components/Start.jsx';
import { Email } from './components/Email.jsx';
import { LoginCode } from './components/LoginCode.jsx';
import { PhoneNumber } from './components/PhoneNumber.jsx';
import { EmployeeId } from './components/EmployeeId.jsx';
import { FullName } from './components/FullName.jsx';
import { Password } from './components/Password.jsx';
import { ResetPassword } from './components/ResetPassword.jsx';
import { SIGN_IN_MODES, SIGN_IN_STEPS } from './contants';
import { SignInProvider } from './SignInProvider.jsx';
import { UnknownEmployeeId } from './components/UnknownEmployeeId.jsx';
import { useGetBoardInfo } from '../CreateAccount/data';

import { SignInContainer } from './SignInContainer.jsx';

const CreateAccount = ({ redirectParam, isModal, showSignInOption }) => {
  const { useEmployeeId } = useSelector(state => state.demoData);
  const { data = {} } = useGetBoardInfo();

  const [userInfo, setUserInfo] = useState({});
  const [step, setStep] = useState(SIGN_IN_STEPS.START);
  const [mode, setMode] = useState(SIGN_IN_MODES.CREATE);
  const [authMethod, setAuthMethod] = useState(null);

  const handleSwitchToSignIn = useCallback(
    e => {
      e.preventDefault();
      setMode(SIGN_IN_MODES.SIGNIN);
      setStep(SIGN_IN_STEPS.START);
      setUserInfo({});
    },
    [setMode, setStep],
  );

  const title =
    mode === SIGN_IN_MODES.SIGNIN
      ? 'Sign In'
      : data.customHeader || 'Create your account';
  const subtitle =
    mode === SIGN_IN_MODES.SIGNIN
      ? 'Pick an option'
      : data.customBody || 'Save your progress and access anytime, anywhere.';

  return (
    <SignInProvider
      step={step}
      setStep={setStep}
      title={title}
      subtitle={subtitle}
      setAuthMethod={setAuthMethod}
      authMethod={authMethod}
      showSignInOption={showSignInOption}
      onSwitchToSignIn={handleSwitchToSignIn}
    >
      <SignInContainer>
        {step === SIGN_IN_STEPS.START && (
          <Start mode={mode} isModal={isModal} />
        )}
        {step === SIGN_IN_STEPS.EMAIL && (
          <Email
            setUserEmail={email => setUserInfo({ email })}
            employeeId={userInfo.employeeId}
            mode={mode}
            useEmployeeId={useEmployeeId}
          />
        )}
        {step === SIGN_IN_STEPS.PHONE && (
          <PhoneNumber
            setUserPhone={phoneNumber => setUserInfo({ phoneNumber })}
            mode={mode}
            employeeId={userInfo.employeeId}
            useEmployeeId={useEmployeeId}
          />
        )}
        {step === SIGN_IN_STEPS.CODE && (
          <LoginCode
            userInfo={userInfo}
            mode={mode}
            redirectParam={redirectParam}
          />
        )}
        {step === SIGN_IN_STEPS.EMPLOYEE_ID && (
          <EmployeeId userInfo={userInfo} setUserInfo={setUserInfo} />
        )}
        {step === SIGN_IN_STEPS.NAME && (
          <FullName setUserInfo={setUserInfo} userInfo={userInfo} />
        )}
        {step === SIGN_IN_STEPS.PASSWORD && (
          <Password
            userInfo={userInfo}
            mode={mode}
            redirectParam={redirectParam}
          />
        )}
        {step === SIGN_IN_STEPS.RESET_PASSWORD && (
          <ResetPassword userInfo={userInfo} mode={mode} />
        )}
        {step === SIGN_IN_STEPS.UNKNOWN_EMPLOYEE_ID && <UnknownEmployeeId />}
      </SignInContainer>
    </SignInProvider>
  );
};

export default CreateAccount;
